import { Component } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';
import { NewsService } from 'src/app/services/news.service';
import { TranslatorService } from 'src/app/services/translator.service';

@Component({
    selector: 'app-dashboardnews',
    templateUrl: './dashboardnews.component.html',
    styleUrls: ['./dashboardnews.component.scss'],
    standalone: false
})
export class DashboardnewsComponent {
     selectedLanguage: string = 'EN';
     firstNewsItemTitle: string = '';
     secondNewsItemTitle: string = '';

     constructor(private translatorService: TranslatorService,
          private newsService: NewsService,
          private generalService: GeneralService
     ) {
          this.selectedLanguage = this.translatorService.getActiveLanguage();
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     ngOnInit(): void {
          const newsPromise = this.newsService.getNews();
          newsPromise.subscribe((result: any) => this.showNews(result));
     }

     get firstItemTitle() {
          return this.firstNewsItemTitle;
     }

     get secondItemTitle() {
          return this.secondNewsItemTitle;
     }

     showNews(results: any[]) {
          this.selectedLanguage = this.translatorService.getActiveLanguage().toUpperCase();
          const langRouteCanSee = this.translatorService.getLanguagesRouteCanSee;
          if(!langRouteCanSee.includes(this.selectedLanguage)){
               this.selectedLanguage = "EN";
          }
          if (results && results[0] === 'true') {
               if (this.newsService.firstNewsItem) {
                    this.firstNewsItemTitle = this.newsService.firstNewsItem.title;
                    if (this.selectedLanguage === 'FR') {
                         this.firstNewsItemTitle = this.newsService.firstNewsItem.title_FR;
                    } else if (this.selectedLanguage === 'ES') {
                         this.firstNewsItemTitle = this.newsService.firstNewsItem.title_ES;
                    }
               }
               if (this.newsService.secondNewsItem) {
                    this.secondNewsItemTitle = this.newsService.secondNewsItem.title;
                    if (this.selectedLanguage === 'FR') {
                         this.secondNewsItemTitle = this.newsService.secondNewsItem.title_FR;
                    } else if (this.selectedLanguage === 'ES') {
                         this.secondNewsItemTitle = this.newsService.secondNewsItem.title_ES;
                    }
               }
          }
     }

     translate(translationTag: string) {
          const language = this.translatorService.getActiveLanguage().toUpperCase();
          if (translationTag === 'Voodoo' && this.selectedLanguage !== language) {
               this.selectedLanguage = language;
               const newsPromise = this.newsService.getNews();
               newsPromise.subscribe((result: any) => this.showNews(result))
          }
          return this.doTranslation(translationTag);
     }

     doTranslation(translationTag: string): string {
          let translatedText: string = this.generalService.getTranslation(translationTag, 'base');
          if (translatedText === undefined) {
               translatedText = this.generalService.getTranslation(translationTag, 'base');
          }
          return translatedText;
     }
}
